module.exports = __webpack_public_path__ + "img/logo-school-11.11d13151.png";